
<div ref="defineTab">
  <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.labelable)" id="pn-name">
    <panel-item>
      <label :for="selectedObjectModelRelation.idForProp('label')">{{ label }}</label>
      <expandable-textarea
        :id="selectedObjectModelRelation.idForProp('label')"
        v-model="selectedObjectModelRelation.label_title"
        :placeholder="placeholder"></expandable-textarea>
    </panel-item>
  </panel-block>
  <panel-block v-if="selectedObjectModelRelation.can(ObjectModelRelationCapability.portalClaimable)" id="pn-portal">
    <panel-item>
      <row>
        <column>
          <label for="portal-for-claiming">Portal for claiming</label>
        </column>
        <suffix>
          <help-tooltip :text="tooltipText"></help-tooltip>
        </suffix>
      </row>
      <a-select
        v-model="selectedObjectModelRelation.portal_for_claiming"
        :options="portalOptions"
        id="portal-for-claiming"
      ></a-select>
    </panel-item>
  </panel-block>
</div>
